import { render, staticRenderFns } from "./saleBallArmActStatistic.vue?vue&type=template&id=7145e5a6&scoped=true"
import script from "./saleBallArmActStatistic.vue?vue&type=script&lang=ts"
export * from "./saleBallArmActStatistic.vue?vue&type=script&lang=ts"
import style0 from "./saleBallArmActStatistic.vue?vue&type=style&index=0&id=7145e5a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145e5a6",
  null
  
)

export default component.exports